
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';
// import  { Auth } from 'aws-amplify';
import { StorageService } from './storage.service';
import { HttpClient } from '@angular/common/http';
import { signIn, confirmSignIn, signOut, getCurrentUser, fetchAuthSession, resetPassword, fetchUserAttributes, confirmResetPassword, updatePassword, AuthUser } from 'aws-amplify/auth';


@Injectable({
  providedIn: 'root'
})
export class AuthNewService {
  user = new BehaviorSubject<AuthUser | null>(null);
  currentUser!: CognitoUser;
  passwordChanged = new BehaviorSubject<boolean>(false);
  forgotPasswordCode = new BehaviorSubject<boolean>(false);
  forgotPasswordErrorMessage = new BehaviorSubject<string>('');
  forgotPasswordMessage = new BehaviorSubject<string | undefined>('');
  userGroup = new BehaviorSubject('');
  forgotMessage?: string | undefined;
  changeMessage = new BehaviorSubject<string>('');;
  signinError = new BehaviorSubject<string>('');
  getCurrentLoginUser = new Subject<CognitoUser>();
  private userPool = new CognitoUserPool(environment.userPool);
  MfaUser = new BehaviorSubject<AuthUser>(null);
  RevokeTokenURL: string = environment.serverUrl + '/revoke_token';
  private userlogInfo = null;

  constructor(private router: Router,
    private http: HttpClient,
    private storageService: StorageService) { }


  // function to signin

  async signIn(username: string, password: string) {
    this.signinError.next('')
    try {
      try {
        await signOut();
      } catch (_) { }

      const { isSignedIn, nextStep } = await signIn({ username, password });
      if (
        nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE' ||
        nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_SMS_CODE' ||
        nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_TOTP_CODE'
      ) {
        return { Status: 'MFA', nextStep };
      } else if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        return { Status: 'NEW_PASSWORD' };
      } else {
        if (isSignedIn) {
          const session = await fetchAuthSession();
          const days_left = session.tokens?.accessToken.payload.days_left;
          const username = session.tokens?.accessToken.payload.username as string;

          const userAttributes = await fetchUserAttributes();

          this.storageService.set('access', userAttributes['custom:access'] ?? '');
          this.storageService.set('organization', userAttributes['custom:organization'] ?? '');
          this.storageService.set('group', userAttributes['custom:group'] ?? '');
          this.storageService.set('userName', userAttributes['name'] ?? '');
          this.storageService.set('days_left', (days_left ?? '').toString());
          this.storageService.set('userId', username);

          return { Status: 'SUCCESS' };
        } else {
          console.log('Unhandled case from signin call:');
          return { Status: 'UNHANDLED' };
        }
      }

    }
    catch (error: any) {
      console.log(error)
      this.signinError.next(error);

    }

  }

  confirmCode(code: string, callback: (error: any, user?: any) => void) {
    confirmSignIn({ challengeResponse: code })
      .then(async () => {
        try {
          const user = await getCurrentUser();
          this.MfaUser.next(user);
          callback(null, user);
        } catch (sessionError) {
          console.error('Error fetching session:', sessionError);
          callback(sessionError);
        }
      })
      .catch((error) => {
        console.error('Error confirming sign-in:', error);
        callback(error);
      });
  }

  // function to handle new password
  async newPassword(password: string): Promise<void> {
    try {
      const { isSignedIn, nextStep } = await confirmSignIn({
        challengeResponse: password,
        options: {
          challenge: 'NEW_PASSWORD_REQUIRED'
        }
      });

      if (isSignedIn) {
        this.passwordChanged.next(true);
      }
      else if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE' ||
        nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_SMS_CODE' ||
        nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_TOTP_CODE') {
        this.router.navigate(['extra-layout/signin'], { queryParams: { MFA_Required: 'true' } })
      }
      else {
        console.log('Next step:', nextStep);
        this.passwordChanged.next(false);
      }
    } catch (error) {
      console.error('Error confirming new password:', error);
      this.passwordChanged.next(false);
    }
  }

  async changePassword(oldPassword: string, newPassword: string) {
    try {
      const data = await updatePassword({ oldPassword, newPassword });
      console.log(data);
      this.changeMessage.next('Password changed successfully');
    } catch (err: any) {
      console.log(err);
      this.changeMessage.next(err);
    }
  }

  getCurrentUser() {
    // Auth.currentAuthenticatedUser({
    //   bypassCache: true
    // }).then(user => {
    //   this.getCurrentLoginUser.next(user);
    // })
    //   .catch(err => {
    //     return err
    //   });

  }

  async getMFACurrentUser() {
    try {
      const user = await getCurrentUser(); // Gets username
      const userAttributes = await fetchUserAttributes(); // Gets attributes like custom:organization, name, etc.
      const username = user.username;
      const days_left = userAttributes['custom:days_left'];

      this.storageService.set('userId', username);
      this.storageService.set('access', userAttributes['custom:access'] ?? '');
      this.storageService.set('organization', userAttributes['custom:organization'] ?? '');
      this.storageService.set('group', userAttributes['custom:group'] ?? '');
      this.storageService.set('userName', userAttributes['name'] ?? '');
      this.storageService.set('days_left', (days_left ?? '').toString());
      this.MfaUser.next(user);
    } catch (error) {
      console.error('Error loading user:', error);
      return error;
    }
  }
  // function to signout
  async signout() {
    this.http.post(this.RevokeTokenURL, this.storageService.get('refreshToken')).subscribe(res => res);
    localStorage.clear();
    sessionStorage.clear();
    await signOut({ global: true });

    this.router.navigate(['extra-layout/home']).then(() => {
      window.location.reload();
    });
  }

  forgetPassword(username: string) {
    resetPassword({ username })
      .then((data) => {
        console.log(data);
        this.forgotPasswordCode.next(true);
      })
      .catch((err) => {
        console.log(err);
        this.forgotPasswordErrorMessage.next(err);
      });
  }

  // Collect confirmation code and new password, then
  async forgetPasswordConfirm(username: string, code: string, password: any, hashedText: any) {
    try {
      await confirmResetPassword({
        username,
        confirmationCode: code,
        newPassword: password,
        options: {
          clientMetadata: hashedText,
        },
      });
      this.forgotMessage = 'Password changed';
      this.forgotPasswordMessage.next(this.forgotMessage);
    }
    catch (error: any) {
      console.error('Reset password error:', error);
      this.forgotMessage = error.message || 'Error occurred';
      this.forgotPasswordMessage.next(this.forgotMessage);
    }
  }

  getAuthenticatedUser() {
    return this.userPool.getCurrentUser();
  }

}
